export default (element, elementIndex, arr) => {
  if (elementIndex < 0 || elementIndex > arr.length - 1) {
    return arr;
  }

  return [...arr.slice(0, elementIndex), element, ...arr.slice(elementIndex + 1)];
};
